import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaLinkedin, FaYoutube } from 'react-icons/fa'; // Assuming YouTube as well

const footerSections = [
  {
    title: 'Product',
    links: [
      { name: 'Features', href: '/features' },
      { name: 'Pricing', href: '/pricing' },
      { name: 'Templates', href: '/templates' },
      { name: 'Mobile Simulator', href: '/mobile-simulator' },
      { name: 'Login', href: '/login' },
      { name: 'Get Started', href: '/get-started' }, // Or /signup
    ],
  },
  {
    title: 'Company',
    links: [
      { name: 'About Us', href: '/about' },
      { name: 'Contact Us', href: '/contact' },
      { name: 'Careers', href: '/careers' }, // Placeholder
    ],
  },
  {
    title: 'Resources',
    links: [
      { name: 'Blog', href: '/blog' }, // Placeholder
      { name: 'Help Center', href: '/help' }, // Placeholder
      { name: 'Use Cases', href: '/use-cases' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { name: 'Privacy Policy', href: '/privacy-policy' }, // Placeholder
      { name: 'Terms of Service', href: '/terms-of-service' }, // Placeholder
      { name: 'Cookie Policy', href: '/cookie-policy' }, // Placeholder
    ],
  },
];

const socialLinks = [
  { name: 'Facebook', href: '#', icon: <FaFacebook /> },
  { name: 'Instagram', href: '#', icon: <FaInstagram /> },
  { name: 'LinkedIn', href: '#', icon: <FaLinkedin /> },
  { name: 'YouTube', href: '#', icon: <FaYoutube /> }, // Added YouTube
];

const Footer = () => {
  return (
    <footer className="bg-dark text-light-gray pt-16 pb-8">
      <div className="container mx-auto px-4">
        {/* Top section: Logo and main link grid */}
        <div className="xl:grid xl:grid-cols-3 xl:gap-8">
          {/* Logo and optional tagline */}
          <div className="space-y-8 xl:col-span-1 mb-10 xl:mb-0">
            <Link to="/" className="inline-block" onClick={() => window.scrollTo(0, 0)}>
              <img
                src="/images/LiveFunnel.png"
                alt="LiveFunnel Logo"
                className="h-8 object-contain" // Consistent height with header logo
              />
            </Link>
            <p className="text-gray-400 text-sm max-w-xs">
              High-converting funnels for automotive dealerships to boost leads and sales.
            </p>
            <div className="flex space-x-5">
              {socialLinks.map(social => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors"
                  aria-label={social.name}
                >
                  {React.cloneElement(social.icon, { className: 'w-6 h-6' })}
                </a>
              ))}
            </div>
          </div>

          {/* Link columns */}
          <div className="mt-12 grid grid-cols-2 gap-8 xl:mt-0 xl:col-span-2 md:grid-cols-4">
            {footerSections.map(section => (
              <div key={section.title}>
                <h3 className="text-sm font-semibold text-gray-300 uppercase tracking-wider">
                  {section.title}
                </h3>
                <ul role="list" className="mt-4 space-y-3">
                  {section.links.map(item => (
                    <li key={item.name}>
                      <Link
                        to={item.href}
                        className="text-base text-gray-400 hover:text-white transition-colors"
                        onClick={() => window.scrollTo(0, 0)} // Scroll to top for footer links too
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom bar: Copyright */}
        <div className="mt-12 border-t border-gray-700 pt-8 text-center">
          <p className="text-base text-gray-400">
            &copy; {new Date().getFullYear()} LiveFunnel. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
